import React from 'react';
import styled from 'styled-components';

import {OzRow, OzCol} from "@ozwol/webui";

const Cnt = styled.div`
  height: 30px;
  padding-top: 40px;
  margin-top: -30px;
`;
const Text = styled.div`
  color: #D18F00;
  background: #FFEAB0;
  padding: 6px 10px;
`;

const ErrorMessage = ({noMargin = false, children}) => {
  if(noMargin){
    return (
      <>
        {children ? 
          <Text>
            {children}
          </Text>
        : null }
      </>  
    )

  }else{
    return (
      <OzRow>
        <OzCol>
          <Cnt>
            {children ? 
              <Text>
                {children}
              </Text>
            : null }
          </Cnt>
        </OzCol>
      </OzRow>
    )

  }
}

export default ErrorMessage;
